module.exports = __webpack_public_path__ + "img/board_of_directors_governance.7eb2aa8a.jpg";